module.exports = __webpack_public_path__ + "img/bg_mask_03.794f7f0d.png";